import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { getDescriptionForAge } from '../../../resources/renderingUtilities'
import {polyglot} from '../../../index'

import './style.css'

// const COLORS = {
//   backgroundColors: {
//     10: '#dff0d8',
//     20: '#e3f0d8',
//     30: '#e6f0d9',
//     40: '#eaf1d9',
//     50: '#eef1da',
//     60: '#f1f1da',
//     70: '#f1eedb',
//     80: '#f1ebdb',
//     90: '#f1e8dc',
//     100: '#f1e5dc',
//     110: '#f2e3dd',
//     120: '#f2e0dd',
//     130: '#f2dede'
//   },
//   borderColors: {
//     10: '#d6e9c6',
//     20: '#dbe9c6',
//     30: '#e0e9c7',
//     40: '#e6eac7',
//     50: '#eae9c8',
//     60: '#eae4c8',
//     70: '#eae0c9',
//     80: '#eadbc9',
//     90: '#ead7ca',
//     100: '#ead3ca',
//     110: '#ebcfcb',
//     120: '#ebcbcc',
//     130: '#ebccd1'
//   },
//   colors: {
//     10: '#3c763d',
//     20: '#467a3d',
//     30: '#527e3e',
//     40: '#5f833f',
//     50: '#6e873f',
//     60: '#7d8b40',
//     70: '#8e9041',
//     80: '#948741',
//     90: '#987d41',
//     100: '#9c7142',
//     110: '#a16342',
//     120: '#a55442',
//     130: '#a94442'
//   }
// }

export class Timeline extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      elements: null
    }
  }

  componentWillMount () {
    this.updateComponentData(this.props.startDate, this.props.data)
  }

  updateComponentData (startDate, data) {
    if (startDate && data) {
      let weeks = {}
      Object.keys(data).forEach(key => {
        const currElement = data[key]
        const date = moment(currElement.date)
        const firstDate = moment(startDate)
        const monthsDifference = date.diff(firstDate, 'month')
        let description = getDescriptionForAge(monthsDifference)
        if (weeks[description]) {
          const element = {
            date: date,
            text: currElement.text,
            state: currElement.state
          }
          weeks[description].push(element)
        } else {
          const element = {
            date: date,
            text: currElement.text,
            state: currElement.state
          }
          weeks[description] = []
          weeks[description].push(element)
        }
        return null
      })
      this.setState({
        elements: weeks
      })
    }
  }

  componentWillReceiveProps (props) {
    this.updateComponentData(props.startDate, props.data)
  }

  render () {
    return <div>
      {this.state.elements
        ? <div className='timeline'>
          {
            Object.keys(this.state.elements).map(function (key) {
              return <div key={key}>
                <h3>{key}</h3>
                <ul>
                  {this.state.elements[key].map((value, index) => {
                    return <li key={index} className={value.state}>
                      <h4><span>{`${value.text}`}</span></h4>
                      <time>{moment(value.date).format('L')}</time>
                    </li>
                  })}
                </ul>
              </div>
            }.bind(this))
          }
        </div>
        : <h3>{polyglot.t('commonFields.noInformation')}</h3>
      }
    </div>
  }
}

Timeline.propTypes = {
  startDate: PropTypes.string.isRequired,
  data: PropTypes.arrayOf(PropTypes.shape({
    date: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    state: PropTypes.oneOf(['green', 'red', 'yellow', 'purple', 'orange']).isRequired
  }))
}



// WEBPACK FOOTER //
// ./src/components/common/Timeline/Timeline.js